import { TableRow, TableCell } from '@mui/material';

const ProductTypesRowsComponent = ({ rows }) => {
  return rows?.map((row) => (
    <TableRow
      key={row.id}
      sx={{
        '&:last-child td, &:last-child th': {
          border: 0,
        },
      }}
    >
      <TableCell>{row.date}</TableCell>

      <TableCell>{row.quantity}</TableCell>
      <TableCell component='th' scope='row'>
        {row.campaign}
      </TableCell>
      <TableCell>{row.channel}</TableCell>
    </TableRow>
  ));
};

export default ProductTypesRowsComponent;
